import { render } from "./FormLayout.vue?vue&type=template&id=39b6db8b&ts=true"
import script from "./FormLayout.vue?vue&type=script&lang=ts"
export * from "./FormLayout.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__